import { getListarCategoriasActivasComercio } from '@/services/Comercios/getListarCategoriasActivasComercio.js';
import { ConfigStore } from "../Config/config.store.js";
import { LoginStore } from "../login.store.js";

const ListarCategoriasActivasComercios = {
    namespaced: true,
    state: {
        listarCategoriasActivasComercios: [],
    },
    mutations: {
        setListarCategoriasActivasComercios(state, payload) {
            state.listaCategoriasActivasComercios = payload.data;
        },
    },
    actions: {
        getListarCategoriasActivasComercios: async function({ commit }) {
                const response = await getListarCategoriasActivasComercio(
                    `${process.env.VUE_APP_API_URL}${ConfigStore.state.endpoints.getListarCategoriasActivasComercio}`,
                    LoginStore.state.token,
                    );
                    if (response.status === 200) {
                        commit("setListarCategoriasActivasComercios", response.data);
                    }
                    
                    return response;
        }
    }
}

export { ListarCategoriasActivasComercios }